export enum RoleEnum {
  VIEWER = "Viewer",
  MEMBER = "Member",
  MANAGER = "Manager",
  ADMIN = "Admin",
  FINANCE_ADMIN = "Finance Admin",
  OWNER = "Owner",
}
